import * as actionTypes from "../constants/actionTypes";
import axios from "axios";
import api from "../shared/api";

export const matchesStart = () => {
    return {
        type: actionTypes.LAST_MATCHES_START,
    }
}

export const matchesSuccess = (matches) => {
    return {
        type: actionTypes.LAST_MATCHES_SUCCESS,
        payload: matches,
    }
}

export const matchesFail = (error) => {
    return {
        type: actionTypes.LAST_MATCHES_FAIL,
        payload: error,
    }
}

export const matches = (token) => {
    return async dispatch => {
        dispatch(matchesStart());
        let url = `${api}/collections/last/all`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {}
        };
        await axios(options)
            .then(response => {
                dispatch(matchesSuccess(response.data));
            })
            .catch(err => {
                dispatch(matchesFail(`Get Matches Failed - ${err}`));
            });
    }
}